import { PublicQuestion } from "@/queries/types";
import { Dispatch } from "react";
import { Action, State } from "../reducer";
import {
  CodeAnswer,
  MultipleOptionsAnswer,
  NumericAnswer,
  PictureOptionsAnswer,
  SingleOptionAnswer,
  TextAnswer,
} from "./ui";

interface Props {
  question: PublicQuestion | undefined;
  endsAt: Date | null;
  state: State;
  isAnswerPasteDisabled: boolean;
  dispatch: Dispatch<Action>;
}

export function ActiveAnswer({
  question,
  endsAt,
  state,
  dispatch,
  isAnswerPasteDisabled,
}: Props) {
  if (!question) return null;

  switch (question.question_type) {
    case "single-choice":
      return (
        <SingleOptionAnswer
          question={question}
          state={state}
          dispatch={dispatch}
        />
      );
    case "multiple-choice":
      return (
        <MultipleOptionsAnswer
          question={question}
          state={state}
          dispatch={dispatch}
        />
      );
    case "picture-question":
      return (
        <PictureOptionsAnswer
          question={question}
          state={state}
          dispatch={dispatch}
        />
      );
    case "free-text":
      return (
        <TextAnswer
          question={question}
          state={state}
          dispatch={dispatch}
          isAnswerPasteDisabled={isAnswerPasteDisabled}
        />
      );
    case "numeric-input":
      return (
        <NumericAnswer question={question} state={state} dispatch={dispatch} />
      );
    case "code-input":
      return (
        <CodeAnswer question={question} state={state} dispatch={dispatch} />
      );
    default:
      return null;
  }
}
